export default __webpack_public_path__ + "static/media/App_Dev.b9fa035c.jpg";